/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 
export { Client } from './Client';

export { ApiError } from './core/ApiError';
export { BaseHttpRequest } from './core/BaseHttpRequest';
export { CancelablePromise, CancelError } from './core/CancelablePromise';
export { OpenAPI } from './core/OpenAPI';
export type { OpenAPIConfig } from './core/OpenAPI';

export type { amenities } from './models/amenities';
export type { amenities_inner } from './models/amenities_inner';
export type { baseDataCampaigns } from './models/baseDataCampaigns';
export type { baseDataCampaigns_inner } from './models/baseDataCampaigns_inner';
export type { baseDataCruise } from './models/baseDataCruise';
export type { baseDataCruise_passengers } from './models/baseDataCruise_passengers';
export type { baseDataCruiseDuration } from './models/baseDataCruiseDuration';
export type { baseDataCruiseDuration_inner } from './models/baseDataCruiseDuration_inner';
export type { baseDataCruisePorts } from './models/baseDataCruisePorts';
export type { baseDataCruisePorts_inner } from './models/baseDataCruisePorts_inner';
export type { baseDataCruiseShips } from './models/baseDataCruiseShips';
export type { baseDataCruiseShips_inner } from './models/baseDataCruiseShips_inner';
export type { baseDataCruiseTariffTypes } from './models/baseDataCruiseTariffTypes';
export type { baseDataCruiseTariffTypes_inner } from './models/baseDataCruiseTariffTypes_inner';
export type { baseDataFlight } from './models/baseDataFlight';
export type { baseDataFlightAirports } from './models/baseDataFlightAirports';
export type { baseDataFlightAirports_inner } from './models/baseDataFlightAirports_inner';
export type { baseDataGeoLocationDestinations } from './models/baseDataGeoLocationDestinations';
export type { baseDataGeoLocationDestinations_inner } from './models/baseDataGeoLocationDestinations_inner';
export type { baseDataGeoLocations } from './models/baseDataGeoLocations';
export type { baseDataPeriods } from './models/baseDataPeriods';
export type { baseDataResponse } from './models/baseDataResponse';
export { boardTypeEnum } from './models/boardTypeEnum';
export { cabinTypeEnum } from './models/cabinTypeEnum';
export type { campaigns } from './models/campaigns';
export type { campaigns_inner } from './models/campaigns_inner';
export { compositionTypeEnum } from './models/compositionTypeEnum';
export type { cruiseListRequest } from './models/cruiseListRequest';
export type { cruiseListResponse } from './models/cruiseListResponse';
export type { cruiseProperties } from './models/cruiseProperties';
export type { cruiseProperties_inner } from './models/cruiseProperties_inner';
export type { cruiseRequest } from './models/cruiseRequest';
export type { cruiseService } from './models/cruiseService';
export type { cruiseServiceLocation } from './models/cruiseServiceLocation';
export type { cruiseServiceLocation_destinations } from './models/cruiseServiceLocation_destinations';
export type { cruiseServiceLocation_route } from './models/cruiseServiceLocation_route';
export type { cruiseServiceLocation_route_ports } from './models/cruiseServiceLocation_route_ports';
export type { cruiseVariantBoard } from './models/cruiseVariantBoard';
export type { cruiseVariantCabin } from './models/cruiseVariantCabin';
export type { cruiseVariants } from './models/cruiseVariants';
export type { cruiseVariants_inner } from './models/cruiseVariants_inner';
export { detailLevelEnum } from './models/detailLevelEnum';
export type { error } from './models/error';
export { flightDirectionEnum } from './models/flightDirectionEnum';
export type { flightRequest } from './models/flightRequest';
export type { flightService } from './models/flightService';
export type { flightsRequest } from './models/flightsRequest';
export type { geoLocationRequest } from './models/geoLocationRequest';
export type { includedServices } from './models/includedServices';
export type { includedServices_inner } from './models/includedServices_inner';
export { includedServiceTypeEnum } from './models/includedServiceTypeEnum';
export { messageTypeEnum } from './models/messageTypeEnum';
export { pagingEntityEnum } from './models/pagingEntityEnum';
export type { pagingType } from './models/pagingType';
export type { passengersRequest } from './models/passengersRequest';
export { passengerTitleEnum } from './models/passengerTitleEnum';
export type { periodDelimiter } from './models/periodDelimiter';
export type { periodRequest } from './models/periodRequest';
export type { priceDetails } from './models/priceDetails';
export type { priceDetails_inner } from './models/priceDetails_inner';
export type { priceDetailsValidity } from './models/priceDetailsValidity';
export type { priceInformation } from './models/priceInformation';
export type { priceInformationPassengers } from './models/priceInformationPassengers';
export type { priceInformationPassengers_inner } from './models/priceInformationPassengers_inner';
export type { priceRequest } from './models/priceRequest';
export { priceTypeEnum } from './models/priceTypeEnum';
export type { processInfo } from './models/processInfo';
export type { processMessages } from './models/processMessages';
export type { processMessages_inner } from './models/processMessages_inner';
export type { productResponse } from './models/productResponse';
export type { productResponse_inner } from './models/productResponse_inner';
export { productTypeEnum } from './models/productTypeEnum';
export { salesChannelEnum } from './models/salesChannelEnum';
export type { serviceReferences } from './models/serviceReferences';
export type { serviceReferences_inner } from './models/serviceReferences_inner';
export type { serviceResponse } from './models/serviceResponse';
export type { serviceResponse_inner } from './models/serviceResponse_inner';
export { sortCrieriaEnum } from './models/sortCrieriaEnum';
export { sortDirectionEnum } from './models/sortDirectionEnum';
export type { sortType } from './models/sortType';

export { BaseDataService } from './services/BaseDataService';
export { ListSearchService } from './services/ListSearchService';
